import React, { type FormEvent, useCallback, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Button } from '../../../../components/Button/Button'
import { ScopesFormFields } from '../../components/ScopesFormFields'

interface ScopesStepProps {
  initialScopes: string[]
  onSubmit: (scopes: string[]) => Promise<void>
  onBack: (scopes: string[]) => void
  isSubmitting: boolean
}

export const ScopesStep: React.FC<ScopesStepProps> = ({ initialScopes, onSubmit, onBack, isSubmitting }) => {
  const [selectedScopes, setSelectedScopes] = useState<string[]>(initialScopes)

  const handleToggle = useCallback((scope: string) => {
    setSelectedScopes((prev) => (prev.includes(scope) ? prev.filter((s) => s !== scope) : [...prev, scope]))
  }, [])

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    onSubmit(selectedScopes)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <h5 className='fw-bold mb-1'>Select app scopes</h5>
      <p className='text-muted mb-4'>Select only the scopes your app needs</p>

      <ScopesFormFields selectedScopes={selectedScopes} onToggle={handleToggle} />

      <div className='d-flex justify-content-end gap-3 mt-4'>
        <Button variant='secondary' className='fw-bold' onClick={() => onBack(selectedScopes)} disabled={isSubmitting}>
          Back
        </Button>
        <Button type='submit' variant='primary' className='fw-bold' disabled={isSubmitting} loading={isSubmitting}>
          Create app
        </Button>
      </div>
    </Form>
  )
}
